module.exports = __webpack_public_path__ + "img/Telegram.95fc511e.svg";